import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiDeleteStatementOfIntent = (fiscal_registry_id: number | undefined, pk: number | undefined): UseMutationResult<void, CustomAxiosError, {
    fiscal_registry_id: number | undefined;
    pk?: number
}, unknown> => {
    const {selectedCompany} = useAuth()
    const queryClient = useQueryClient();

    const {DELETE} = useApiCalls()

    async function doDelete({companyToken, fiscal_registry_id, pk}: {
        companyToken?: string,
        fiscal_registry_id: number | undefined,
        pk?: number
    }): Promise<void> {
        try {
            await DELETE(`/api/company/${companyToken}/my_documents/fiscal_registry/${fiscal_registry_id}/statement_of_intent/${pk}/`);
        } catch (error) {
            throw error;
        }
    }

    return useMutation<void, CustomAxiosError, { fiscal_registry_id: number | undefined, pk?: number }>(
        {
            mutationFn: () => doDelete({
                companyToken: selectedCompany?.company_token,
                fiscal_registry_id: fiscal_registry_id,
                pk: pk,
            }),
            onSuccess: async () => {
                await queryClient.invalidateQueries({queryKey: ["useApiGetStatementOfIntents", fiscal_registry_id]});
                await queryClient.invalidateQueries({queryKey: ["useApiGetStatementOfIntent", fiscal_registry_id, pk]});
            },
        })
}


export default useApiDeleteStatementOfIntent;